import React from 'react';
import PropTypes from 'prop-types';

import { Container, Wrapper } from './styles';

function AuthSigninLayout({ children }) {
  return (
    <Container>
      <Wrapper>{children}</Wrapper>
    </Container>
  );
}

AuthSigninLayout.propTypes = {
  children: PropTypes.element.isRequired,
};

export { AuthSigninLayout };
